export function coalesceNaN<T>(leftHandSide: number, rightHandSide: T) {
    if (isNaN(leftHandSide))
        return rightHandSide;
    else
        return leftHandSide;
}
